import { cn } from "@/lib/utils";

/** Soft accent track + fill — matches card surfaces and primary actions. */
export function ProgressBar({
  value,
  className,
  trackClassName,
  label,
}: {
  /** 0–100 */
  value: number;
  className?: string;
  trackClassName?: string;
  /** Accessible name; defaults to a generic progress label. */
  label?: string;
}) {
  const clamped = Math.min(100, Math.max(0, value));
  const rounded = Math.round(clamped);

  return (
    <div
      role="progressbar"
      aria-valuenow={rounded}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
      className={cn(
        "h-2 overflow-hidden rounded-full bg-accent-soft",
        trackClassName,
        className,
      )}
    >
      <div
        className="h-full rounded-full bg-accent transition-[width] duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
